// Auto-generated from CDK outputs - DO NOT EDIT MANUALLY
export const USER_POOL_ID = 'us-east-1_y6i1Nkj2e';
export const USER_POOL_CLIENT_ID = '4rdfe6kphgeap2a5unf2q0vk5h';
export const REGION = 'us-east-1';
export const COGNITO_DOMAIN = 'https://auth.uncola.ai';
